export default __webpack_public_path__ + "static/media/icon-question.d96a0528.svg";